import Sha256Encode from "../../components/sha256";

export default async function ContentImageUploader(jsonRequest: any, image: any, data: any) {
    const file: any = await handleImgFile(image, data)
    console.log(file);
    var formData = new FormData()
    // file.url=`${file.url}`
    formData.append('key', file.url)
    formData.append('policy', data.policy)
    formData.append('OSSAccessKeyId', data.keyId)
    formData.append('Signature', data.signature)
    // formData.append('success_action_status', '200')
    formData.append('file', file)
    console.log(file.url)
    let url = await fetch(data.host, { method: 'POST', body: formData, mode: 'cors' });
    console.log(url, 'url');
    const result = await jsonRequest.get(`/common/oss-file-visit-url`, { fileUrl: data.host + "/" + file.url })
        .then((resp: any) => resp.json());
    return result?.data;
}

const handleImgFile = async (file: any, OSSData: any) => {
    const file_content = await file.arrayBuffer()
    const file_name = await Sha256Encode(file_content)
    console.log();
    console.log(OSSData.host, OSSData)
    // file.url = OSSData.host+"/"+[OSSData?.dir, file_name].join("/");
    file.url = [OSSData?.dir, file_name].join("/");
    console.log(file.url)
    return file;
}